export * from './firebaseConfig'

